import React from 'react';

import { flagStyles } from '../settings';

const SvgMZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3768px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMZ;
